import React, {useEffect, useMemo, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {selectCodesByParentId} from "../../../../../api/code/CodeService";
import {useSelector} from "react-redux";
import Search from "../../../../../components/search/Search";
import {handleActiveToast} from "../../../../../components/sonner/ToastBasic";
import {removePurchases} from "../../../../../api/asset/PurchaseService";
import {CodeSpecNum} from "../../../../../constant/CodeSpecNum";
import {PURCHASE_LIST_HEADER} from "../../../../../components/table/header/Headers";
import SearchSection from "../../../../../components/search/SearchSection";
import {getIndividualSetting, resetIndividualSetting, setIndividualSetting} from "../../../../../api/user/UserAccountService";
import {extractObject, initHeaderOrders, simmsColumnsToJsGridHeaders} from "../../../../../components/commonmethod/CommonMethod";
import {searchWithChildren} from "../../../../../components/commonmethod/simmsDrawerMethod";
import Selector from "../../../../../components/selector/Selector";
import {ToolbarDataTransfer} from "@bavuchoko/js-grid";
import SimmsJsGrid from "../../../../../components/js-grid/SimmsJsGrid";
import {navigateWithChildTab, pickDetailTabTitle} from "../../../../../components/pageTabs/pageTabsStorage";
import {useExcelDownloadClick} from "../../../../../components/commonmethod/excelMethod";
import JsGridExcelGridOpenButton from "../../../../../components/js-grid/JsGridExcelGridOpenButton";

function PurchaseListListType({checked, data, date, dataHook, pageInfo}) {
    const navigate = useNavigate();
    const [purchaseCode, setPurchaseCode] = useState();
    const reload = useSelector(state => state.api.status);
    const {handleSearch, handlePageSizeChange, saveConditions, refresh, handleGridPageChange} = dataHook;
    const handleDownloadClick = useExcelDownloadClick(saveConditions);

    const [header, setHeader] = useState({order: PURCHASE_LIST_HEADER, exclude: []});

    const searchDate = {startDate: saveConditions.startDate ?? date.startDate, endDate: saveConditions.endDate ?? date.endDate};

    const handleRowClick = (row) => {
        const id = row?.id;
        if (id == null) return;
        navigateWithChildTab(navigate, {
            title: pickDetailTabTitle(row, "구매 상세"),
            url: `/asset/purchase/${id}`,
        });
    };

    const deletePurchase = async (rows) => {
        if (!rows?.length) {
            handleActiveToast({message: "삭제할 구매를 선택해주세요."});
            return;
        }
        if (!window.confirm("삭제하시겠습니까?")) {
            return;
        }
        try {
            const ids = rows.map((row) => row.id).filter((id) => id != null);
            const response = await removePurchases({ids});
            if (response.status === 200) {
                handleActiveToast({message: "구매가 삭제되었습니다."});
                checked?.setChecked?.([]);
                refresh();
            } else {
                handleActiveToast({message: "삭제할 권한이 없습니다."});
            }
        } catch (error) {
            if (error.response?.status === 403) {
                handleActiveToast({message: "삭제할 권한이 없습니다."});
            } else {
                alert("서버와 연결할 수 없습니다. 잠시 후 다시 시도하세요.");
                throw new Error("서버 연결 실패");
            }
        }
    };

    useEffect(() => {
        selectCodesByParentId(CodeSpecNum.PurchaseGroupCode).then((_) => {
            if (_.status === 200) {
                setPurchaseCode(_.data);
            }
        }).catch(error => console.log(error));
    }, [reload]);

    useEffect(() => {
        getIndividualSetting().then((r) => {
            initHeaderOrders(r, PURCHASE_LIST_HEADER, setHeader, [], () => {}, () => {}, 'purchase');
        });
    }, []);

    const purchaseJsGridHeader = useMemo(() => simmsColumnsToJsGridHeaders(header), [header]);
    const excelGridSearch = useMemo(() => extractObject(saveConditions), [saveConditions]);

    return (
        <div className="container-height">
            <Search refresh={refresh} entity={'purchase'} searchConditions={saveConditions} handleSearch={handleSearch} handlePageSizeChange={handlePageSizeChange} pageInfo={pageInfo} searchBar={{placeHolder: '명칭, 구매번호'}} size detail date={searchDate}>
                <SearchSection>
                    <Selector showLabel onChange={(value) => searchWithChildren(handleSearch, 'category', extractObject(saveConditions), value)}
                                 data={saveConditions.category}
                                 parentKey={CodeSpecNum.PurchaseSupplyCategoryCode} recursive
                                 entity={"code"} title={"공급구분"} />

                    <Selector showLabel onChange={(value) => searchWithChildren(handleSearch, 'method', extractObject(saveConditions), value)}
                                 data={saveConditions.method}
                                 parentKey={CodeSpecNum.PurchaseSupplyMethodCode} recursive
                                 entity={"code"} title={"공급방법"} />
                </SearchSection>
            </Search>

            <div className="container-height-body">
                <SimmsJsGrid
                    loading={dataHook.loading}
                    resizable={true}
                    data={data}
                    theme={'linear'}
                    style={{minHeight: 0, height: '100%'}}
                    header={purchaseJsGridHeader}
                    onHeaderSave={(v) => setIndividualSetting({headers: {purchase: v}})}
                    onHeaderReset={() => resetIndividualSetting('headers', 'purchase')}
                    enableRowSelection={true}
                    onRowClick={handleRowClick}
                    onPageChange={handleGridPageChange}
                    toolbarEnd={() => (
                        <div className="flex items-center gap-2">
                            <JsGridExcelGridOpenButton entityName="Purchase" search={excelGridSearch} />
                            <ToolbarDataTransfer
                                hint="선택 항목 삭제"
                                busyHint="삭제 중…"
                                overlayLabel="삭제 중…"
                                onTransfer={deletePurchase}
                            >
                                {(ctx) => (
                                    <button
                                        type="button"
                                        className="text-[13px] px-3 py-0.5 text-black rounded-4 border disabled:cursor-not-allowed"
                                        disabled={ctx.disabled}
                                        onClick={() => void ctx.transferSelected()}
                                    >
                                        삭제
                                    </button>
                                )}
                            </ToolbarDataTransfer>
                            <button
                                type="button"
                                className="text-[13px] px-3 py-0.5 border text-white bg-themeDark rounded-4"
                                onClick={() => navigate('/asset/purchase/create')}
                            >
                                등록
                            </button>
                        </div>
                    )}
                />
            </div>
        </div>
    );
}
export default PurchaseListListType;
